module.exports = __webpack_public_path__ + "static/media/accountant.43fe4fee.svg";